<!-- START: Section 2 -->
<section class="business-register-by-email-wrapper">
  <div class="box-container">
    <div class="partner-topic">
      <!-- desktop heading-->
      <h2
        class="partner-topic__heading partner-topic__heading--desktop color-gray"
        [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.HEADING' | translate"
      >
      </h2>

      <!-- tablet heading-->
      <div
        class="partner-topic__heading partner-topic__heading--tablet color-gray"
        [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.HEADING_TABLET' | translate"
      >
      </div>

      <!-- mobile heading -->
      <div
        class="partner-topic__heading partner-topic__heading--mobile color-gray"
        [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.HEADING_MOBILE' | translate"
      >
      </div>

      <div class="partner-topic__heading-detail">
        {{ 'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.DETAIL' | translate }}
      </div>
    </div>

    <div class="box">
      <div class="box__left">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/functions/business/business_step5_v1.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/functions/business/business_step5_v2.png"
            width="100%"
            loading="lazy"
            alt="ดำเนินการจดบริษัทง่ายและจบไว ใน 5 ขั้นตอน"
            class="box__image"
          />
        </picture>
      </div>
      <div class="box__right">
        <ng-container *ngFor="let item of loopArray(5); let i = index">
          <div class="box__item">
            <div
              class="box__item--heading color-gray"
              [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.ITEM.MESSAGE_' + (i + 1) | translate"
            >
            </div>
            <div
              class="box__item--detail"
              [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_BY_EMAIL.ITEM.DETAIL_' + (i + 1) | translate"
            >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<!-- END: Section 2 -->
